import { useState } from 'react'
import { useLicencia } from '../context/LicenciaContext'
import { useConfig } from '../context/ConfigContext'

export default function Activacion() {
  const { estado, diasRestantes, activar } = useLicencia()
  const { config } = useConfig()
  const [codigo, setCodigo] = useState('')
  const [cargando, setCargando] = useState(false)
  const [errorMsg, setErrorMsg] = useState(null)

  const esExpirado = estado === 'expirado'
  const esVencido  = estado === 'vencido'

  async function handleActivar(e) {
    e.preventDefault()
    if (!codigo.trim()) return
    setCargando(true)
    setErrorMsg(null)
    try {
      await activar(codigo.trim())
      // LicenciaContext cambia estado a 'activo' → LicenciaGuard deja pasar
    } catch (err) {
      setErrorMsg(err.message)
    } finally {
      setCargando(false)
    }
  }

  return (
    <div className="min-h-screen bg-tienda-bg flex flex-col items-center justify-center px-6 py-12">
      {/* Logo */}
      <div className="flex items-center gap-3 mb-8">
        <span className="text-4xl">🛒</span>
        <span className="text-2xl font-bold text-tienda-text">{config.nombreTienda}</span>
      </div>

      <div className="w-full max-w-sm space-y-6">

        {/* Mensaje de estado */}
        {esExpirado && (
          <div className="bg-tienda-surface border border-tienda-border rounded-2xl p-5 text-center space-y-2">
            <p className="text-2xl">⏰</p>
            <p className="text-tienda-text font-bold text-lg">Periodo de prueba terminado</p>
            <p className="text-tienda-muted text-sm">
              Tu prueba gratuita de 30 días ha concluido. Ingresa tu código de activación para continuar.
            </p>
          </div>
        )}

        {esVencido && (
          <div className="bg-tienda-surface border border-tienda-danger/40 rounded-2xl p-5 text-center space-y-2">
            <p className="text-2xl">🔄</p>
            <p className="text-tienda-text font-bold text-lg">Suscripción vencida</p>
            <p className="text-tienda-muted text-sm">
              Tu suscripción de sincronización ha expirado. Renueva e ingresa tu nuevo código para continuar.
            </p>
          </div>
        )}

        {/* Formulario de activación */}
        <form onSubmit={handleActivar} className="space-y-4">
          <div>
            <label className="block text-tienda-muted text-xs font-semibold mb-2 uppercase tracking-wide">
              Código de activación
            </label>
            <textarea
              value={codigo}
              onChange={e => { setCodigo(e.target.value); setErrorMsg(null) }}
              placeholder="Pega aquí tu código..."
              rows={4}
              className="input-field w-full text-xs font-mono resize-none"
              autoCorrect="off"
              autoCapitalize="none"
              spellCheck={false}
            />
          </div>

          {errorMsg && (
            <div className="bg-tienda-danger/10 border border-tienda-danger/30 rounded-xl px-4 py-3">
              <p className="text-tienda-danger text-sm font-semibold">❌ {errorMsg}</p>
            </div>
          )}

          <button
            type="submit"
            disabled={!codigo.trim() || cargando}
            className="btn-primary w-full"
          >
            {cargando ? 'Verificando...' : 'Activar'}
          </button>
        </form>

        {/* Contacto */}
        <a
          href="https://wa.me/528126275377"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-2 w-full py-3 rounded-xl border border-tienda-border text-tienda-muted text-sm font-semibold active:bg-tienda-surface transition-colors"
        >
          <svg className="w-5 h-5 text-tienda-success" viewBox="0 0 24 24" fill="currentColor">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
            <path d="M12 0C5.373 0 0 5.373 0 12c0 2.124.558 4.121 1.535 5.853L.057 23.5l5.835-1.53A11.943 11.943 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.894a9.884 9.884 0 0 1-5.031-1.378l-.361-.214-3.741.981.999-3.648-.235-.374A9.861 9.861 0 0 1 2.106 12C2.106 6.58 6.58 2.106 12 2.106c5.421 0 9.894 4.474 9.894 9.894 0 5.421-4.473 9.894-9.894 9.894z"/>
          </svg>
          Contactar a Practicaja
        </a>
      </div>
    </div>
  )
}
